var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.125 6.417H7.899C6.917 4.743 5.26 4.483 4.453 4.593l-1.045.149.943 3.235a6.85 6.85 0 00-1.718 2.106H0V16.5h2.627a6.844 6.844 0 005.623 3.636V22h1.833v-1.833h3.667V22h1.833v-1.856C19.16 19.906 22 16.928 22 13.292a6.882 6.882 0 00-6.875-6.875zm.458 5.5H9.167v-1.834h6.416v1.834z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12.375,
  cy: 2.292,
  r: 2.292
}));

var SvgContributionsPiggyBank = function SvgContributionsPiggyBank(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContributionsPiggyBank, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contributions -piggy-bank.e64f2b13.svg";
export { ForwardRef as ReactComponent };